import { DxSingleSelect, DxSingleSelectItem } from '@dvag/design-system-react';
import { consentType as consentTypes } from 'service/model/consentType';
import { checkIcon } from 'utils/util';
import i18next from 'i18next';

interface ConsentTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  isSignatureDisabled: boolean;
  isSubmitting: boolean;
  isConsentFetching: boolean;
  emailAlreadySent: boolean | undefined;
  readMode: boolean;
}

export const ConsentTypeSelect = ({
  value,
  onChange,
  isSignatureDisabled,
  isSubmitting,
  isConsentFetching,
  emailAlreadySent,
  readMode,
}: ConsentTypeSelectProps) => {
  const translation = {
    question: i18next.t('sendConsent.question'),
    bySignature: i18next.t('sendConsent.consentOrLegalGuardianModal.bySignature'),
    byEmail: i18next.t('sendConsent.consentOrLegalGuardianModal.byEmail'),
  };
  return (
    <DxSingleSelect
      size="m"
      columns={2}
      value={value}
      onValueChange={(e) => onChange(e.detail)}
      data-testid="consent-single-select"
      id="consent-single-select"
      label={translation.question}
      disabled={readMode}
    >
      <DxSingleSelectItem
        value={consentTypes.SIGNATURE}
        icon={checkIcon('unterschreiben')}
        data-testid="consent-by-signature"
        id="consent-by-signature"
        disabled={isSignatureDisabled || isSubmitting}
        label={translation.bySignature}
      />
      <DxSingleSelectItem
        value={consentTypes.EMAIL}
        icon={checkIcon('mail')}
        data-testid="consent-by-email"
        id="consent-by-email"
        disabled={isSubmitting || isConsentFetching || emailAlreadySent}
        label={translation.byEmail}
      />
    </DxSingleSelect>
  );
};
